module.exports = __webpack_public_path__ + "static/media/wishlist.b79169b6.svg";